module.exports = __webpack_public_path__ + "static/navybearhamper-18bf73f3f9172a5d93f729ab7eb27af4.jpeg";